var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",staticClass:"contact-search"},[_vm._t("default",null,{"hits":_vm.hits,"facets":_vm.facets,"facetItems":_vm.facetItems,"totalCount":_vm.totalCount,"totalPageCount":_vm.totalPageCount,"loading":_vm.loading,"query":_vm.internalQuery,"refine":_vm.refine,"reload":_vm.reload,"fetchAll":_vm.fetchAll})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }